export default __webpack_public_path__ + "static/media/integrations.32a91ca3.svg";